import React, { useState, useEffect } from "react";

export default function PaymentPrompt({ confirmHandler, closeHandler, message }) {
    
    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>{message}</h3>                
                <div className="modal-actions">
                    <button className="confirm-btn" onClick={confirmHandler}>Yes</button>
                    <button className="close-btn" onClick={closeHandler}>No</button>
                </div>
            </div>
        </div>
    )
}